import { render, staticRenderFns } from "./FlatIcon.vue?vue&type=template&id=5dfe7e0a&scoped=true&"
import script from "./FlatIcon.vue?vue&type=script&lang=js&"
export * from "./FlatIcon.vue?vue&type=script&lang=js&"
import style0 from "./FlatIcon.vue?vue&type=style&index=0&id=5dfe7e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe7e0a",
  null
  
)

export default component.exports